import UserService from 'utils/userService';

export type MarketingConsentScope = 'channel5' | 'viacom';

export interface MarketingConsentModalConfig {
    modalTitle: string;
    modalCopy: string;
    Channel5AndMy5Text: string;
    viacomcbsText: string;
    communicationButton1: string;
    communicationButton2: string;
    modalpolicyLink: string;
    modalpolicyUrl: string;
    modalpolicyFooterText?: string;
}

export interface MarketingConsentState {
    channel5: boolean;
    viacom: boolean;
}

export const shouldShowMarketingConsentModal = async (): Promise<boolean> => {
    try {
        const userService = new UserService();
        const marketingConsentSettings = await userService.getMarketingConsentSetting();
        return Array.isArray(marketingConsentSettings) && marketingConsentSettings.length === 0;
    } catch (error) {
        return false;
    }
};

export const toggleMarketingConsent = (
    state: MarketingConsentState,
    scope: MarketingConsentScope
): MarketingConsentState => ({ ...state, [scope]: !state[scope] });

const DEFAULT_DECLINED_STATE: MarketingConsentState = { channel5: false, viacom: false };

export const saveMarketingConsent = async (state: MarketingConsentState = DEFAULT_DECLINED_STATE): Promise<void> => {
    const userService = new UserService();
    await userService.updateMarketingConsentSettingValues([
        { scope: 'Channel5', value: state.channel5 },
        { scope: 'Viacom', value: state.viacom },
    ]);
};
